/**
 * Full-label (A5) search terms: one parser for the URL `highlight` / Find text,
 * and the plain-text highlighter that shares `findTermRanges` with the SPL path.
 */
import React from 'react';
import { findTermRanges } from '../components/SplContentRenderer';
import { HIGHLIGHT_STOP_WORDS } from './drugDetailUtils';

export function parseLabelTerms(text: string, mode: { jpja: boolean; phrase: boolean }): string[] {
  if (mode.jpja) return text.split(/\s+/).filter(Boolean);
  if (mode.phrase) return [text.toLowerCase().trim()].filter(Boolean);
  return text
    .toLowerCase()
    .split(/\s+/)
    .filter((term) => term.length >= 3 && !HIGHLIGHT_STOP_WORDS.has(term));
}

/** Plain-text path (R5.1): same ranges as the SPL path; no animate-pulse (R5.7). */
export function highlightPlainText(text: string, terms: string[], englishExact = false): React.ReactNode {
  const ranges = findTermRanges(text, terms, englishExact);
  if (!ranges.length) return text;
  const parts: React.ReactNode[] = [];
  let last = 0;
  ranges.forEach((r, i) => {
    if (r.start > last) parts.push(text.slice(last, r.start));
    parts.push(
      <mark key={i} className="search-highlight bg-amber-200 px-0.5 rounded">
        {text.slice(r.start, r.end)}
      </mark>,
    );
    last = r.end;
  });
  if (last < text.length) parts.push(text.slice(last));
  return parts;
}
